import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { GameProvider } from '../context/GameContext';
import PlayerHome from './PlayerHome';
import PlayerGame from './PlayerGame';
import PlayerScore from './PlayerScore';

export default function PlayerApp() {
  return (
    <GameProvider>
      <Routes>
        <Route path="/" element={<PlayerHome />} />
        <Route path="/game" element={<PlayerGame />} />
        <Route path="/scores" element={<PlayerScore />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </GameProvider>
  );
}
